(function($) {




    //mostra nasconde navbar
    var $header = $('#wrapper-navbar');

    $(window).on("scroll", function() {

        

        let scrollTop = $(document).scrollTop();

        if(scrollTop > 100){
            $header.addClass('sticky');
        }else{
            $header.removeClass('sticky');
        }

    });



    //$($('#navbarNavDropdown .menu-item').get().reverse()).each(function(i){   
   /* $($('.navbar-nav > .menu-item').get().reverse()).each(function(i){
        var item = $(this);

        setTimeout(function(){
            item.addClass('show-menu-item');
        },i*200);

    });
*/
    
    /*
    $('.menu-item-has-children.dropdown').on('click',function(){
        if($(this).find(".menu-item").hasClass('show-menu-item')){
            HideMenuItem($(this).find(".menu-item"));
        }else{
            ShowMenuItem($(this).find(".menu-item"));
        }
        
        //HideMenuItem('.navbar-nav > .menu-item');
    });
    */
    

    function ShowMenuItem(elements){
        $($(elements).get().reverse()).each(function(i){
            var item = $(this);
    
            setTimeout(function(){
                item.addClass('show-menu-item');
            },i*200);
    
        });
    }
    

    function HideMenuItem(elements){
        $($(elements).get().reverse()).each(function(i){
            var item = $(this);
    
            setTimeout(function(){
                item.removeClass('show-menu-item');
                //item.addClass('hide-menu-item');
            },i*200);
    
        });
    }


    


    jQuery('.smx-navbar-toggler').on('click', function () {

        //alert('prova');
        var open = this.getAttribute("aria-expanded");
        
    
        if( open == 'false' ){
            jQuery('#menu-overlay').addClass('menu-show');

            setTimeout(function(){
                ShowMenuItem('.navbar-nav > .menu-item');
            },400);

            
        }else{
            jQuery('#menu-overlay').removeClass('menu-show');
            HideMenuItem('.navbar-nav > .menu-item');
        }
      })
    
    
    jQuery('#menu-overlay').on('click', function() {
        var toggler = jQuery('.smx-navbar-toggler');
        var navbar = jQuery('#navbarNavDropdown');
        
    
        if(navbar.hasClass('show')){
            navbar.removeClass('show');
            toggler.attr("aria-expanded","false");
            jQuery('#menu-overlay').removeClass('menu-show');
            jQuery('html').removeClass('overflow-hidden');
            HideMenuItem('.navbar-nav > .menu-item');
        }
    
    });

    


})
(jQuery); 